import { trackPageRequest } from './appComponents/shared/PageLoadingService';
import { authenticatedPut } from './appComponents/shared/AuthenticatedAPI';
import Amplify, { Auth, Storage, API } from 'aws-amplify'
import './../styles/Register.css'; // Tell webpack that Button.js uses these styles
import './../index.css';
import React, {Component, Fragment, useRef} from 'react';
import axios from 'axios';
import { ethers } from 'ethers';

import {isMobile} from 'react-device-detect';


import blenderCommissionPublicKey from '../blenderData/blenderCommissionPublicKey.js';
import blenderTransfersToPublicKey from '../blenderData/blenderTransfersToPublicKey.js';

import awsconfig from '../aws-exports.js';
import { navigationHandler, routeProps } from '../utilities/navigator.js';
import LoadingIcons from 'react-loading-icons'
import { Mosaic, OrbitProgress, ThreeDot } from "react-loading-indicators";

import deploymentAddressLatest from '../ethereum/deploymentAddress.js';
import CampaignContract_latest from '../ethereum/build/latest/Campaign.json';
import CampaignFactoryContract_latest from '../ethereum/build/latest/CampaignFactory.json';

import { tokenLifeTimeLimit, checkValidAuthTokenIntervalPeriod_ms, LENDERBLOCKADMINWHITELIST} from '../blenderData/securityConfigurations.js';
import { Link, useParams } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css' 
import { 
  Button, 
  ButtonContent,
  ButtonGroup,
  Dropdown,
  DropdownMenu,
  Modal, 
  Header, 
  Image, 
  Container,  
  ListList,
  ListItem,
  ListIcon,
  Icon,
  Input, 
  ListHeader,
  ListDescription, 
  ListContent,
  List,
  FormField, 
  Form, 
  Radio,
} from 'semantic-ui-react';


import { Buffer } from 'buffer';
import * as bip39 from 'bip39';
import RegisterMobileRender from './register/RegisterMobileRender.jsx';
import RegisterDesktopRender from './register/RegisterDesktopRender.jsx';

global.Buffer = Buffer; 

var primaryLanguage;
var mode_light_dark;

const Web3 = require('web3');

const CryptoJS = require("crypto-js");

var AWS = require('aws-sdk');
var region = "us-east-1"

var mimemessage = require('mimemessage');
var secretName = "PrivateBlenderKeys"

let axiosDoubleCallCounter

Amplify.configure(awsconfig);
Auth.configure(awsconfig);

var checkValidAuthTokenInterval;

var currentUser;
var checkValidAccountInterval;
var that;
var currentUser;

var weiBalance;
var cognitoID;
var startCount;
var createAccountTimer;
var applicantUsername;
var web3;


var countryCodesJSON = 
  [ 
    { "value": "United States", "text": "United States", "dial_key": "+1", "key": "US" }, 
    { "value": "United Kingdom", "text": "United Kingdom", "dial_key": "+44", "key": "GB" }, 
    { "value": "Albania", "text": "Albania", "dial_key": "+355", "key": "AL" }, 
    { "value": "Antigua and Barbuda",  "text": "Antigua and Barbuda", "dial_key": "+1268", "key": "AG" }, 
    { "value": "Argentina", "text": "Argentina", "dial_key": "+54", "key": "AR" }, 
    { "value": "Armenia", "text": "Armenia", "dial_key": "+374", "key": "AM" }, 
    { "value": "Australia", "text": "Australia", "dial_key": "+61", "key": "AU" }, 
    { "value": "Austria", "text": "Austria", "dial_key": "+43", "key": "AT" }, 
    { "value": "Bahrain", "text": "Bahrain", "dial_key": "+973", "key": "BH" }, 
    { "value": "Belgium", "text": "Belgium", "dial_key": "+32", "key": "BE" }, 
    { "value": "Bolivia", "text": "Bolivia", "dial_key": "+591", "key": "BO" }, 
    { "value": "Bosnia and Herzegovina", "text": "Bosnia and Herzegovina", "dial_key": "+387", "key": "BA" }, 
    { "value": "Brazil", "text": "Brazil", "dial_key": "+55", "key": "BR" }, 
    { "value": "Bulgaria", "text": "Bulgaria", "dial_key": "+359", "key": "BG" }, 
    { "value": "Cambodia", "text": "Cambodia", "dial_key": "+855", "key": "KH" }, 
    { "value": "Canada", "text": "Canada", "dial_key": "+1", "key": "CA" }, 
    { "value": "Chile", "text": "Chile", "dial_key": "+56", "key": "CL" }, 
    { "value": "Colombia", "text": "Colombia", "dial_key": "+57", "key": "CO" }, 
    { "value": "Costa Rica", "text": "Costa Rica", "dial_key": "+506", "key": "CR" }, 
    { "value": "Cote d'Ivoire", "text": "Cote d'Ivoire", "dial_key": "+225", "key": "CI" }, 
    { "value": "Croatia", "text": "Croatia", "dial_key": "+385", "key": "HR" }, 
    { "value": "Cyprus", "text": "Cyprus", "dial_key": "+357", "key": "CY" }, 
    { "value": "Czech Republic", "text": "Czech Republic", "dial_key": "+420", "key": "CZ" }, 
    { "value": "Denmark", "text": "Denmark", "dial_key": "+45", "key": "DK" }, 
    { "value": "Dominican Republic", "text": "Dominican Republic", "dial_key": "+1849", "key": "DO" }, 
    { "value": "Ecuador", "text": "Ecuador", "dial_key": "+593", "key": "EC" }, 
    { "value": "Egypt", "text": "Egypt", "dial_key": "+20", "key": "EG" }, 
    { "value": "El Salvador", "text": "El Salvador", "dial_key": "+503", "key": "SV" }, 
    { "value": "Estonia", "text": "Estonia", "dial_key": "+372", "key": "EE" }, 
    { "value": "Ethiopia", "text": "Ethiopia", "dial_key": "+251", "key": "ET" },  
    { "value": "Finland", "text": "Finland", "dial_key": "+358", "key": "FI" }, 
    { "value": "France", "text": "France", "dial_key": "+33", "key": "FR" }, 
    { "value": "Gambia", "text": "Gambia", "dial_key": "+220", "key": "GM" }, 
    { "value": "Germany", "text": "Germany", "dial_key": "+49", "key": "DE" }, 
    { "value": "Ghana", "text": "Ghana", "dial_key": "+233", "key": "GH" }, 
    { "value": "Greece", "text": "Greece", "dial_key": "+30", "key": "GR" }, 
    { "value": "Guatemala", "text": "Guatemala", "dial_key": "+502", "key": "GT" }, 
    { "value": "Guyana", "text": "Guyana", "dial_key": "+595", "key": "GY" }, 
    { "value": "Hong Kong", "text": "Hong Kong", "dial_key": "+852", "key": "HK" }, 
    { "value": "Hungary", "text": "Hungary", "dial_key": "+36", "key": "HU" }, 
    { "value": "Iceland", "text": "Iceland", "dial_key": "+354", "key": "IS" },
    { "value": "India", "text": "India", "dial_key": "+91", "key": "IN" },  
    { "value": "Indonesia", "text": "Indonesia", "dial_key": "+62", "key": "ID" }, 
    { "value": "Ireland", "text": "Ireland", "dial_key": "+353", "key": "IE" }, 
    { "value": "Israel", "text": "Israel", "dial_key": "+972", "key": "IL" }, 
    { "value": "Italy", "text": "Italy", "dial_key": "+39", "key": "IT" }, 
    { "value": "Jamaica", "text": "Jamaica", "dial_key": "+1876", "key": "JM" }, 
    { "value": "Japan", "text": "Japan", "dial_key": "+81", "key": "JP" }, 
    { "value": "Jordan", "text": "Jordan", "dial_key": "+962", "key": "JO" }, 
    { "value": "Kenya", "text": "Kenya", "dial_key": "+254", "key": "KE" }, 
    { "value": "Kuwait", "text": "Kuwait", "dial_key": "+965", "key": "KW" }, 
    { "value": "Latvia", "text": "Latvia", "dial_key": "+371", "key": "LV" }, 
    { "value": "Liechtenstein", "text": "Liechtenstein", "dial_key": "+423", "key": "LI" }, 
    { "value": "Lithuania", "text": "Lithuania", "dial_key": "+370", "key": "LT" }, 
    { "value": "Luxembourg", "text": "Luxembourg", "dial_key": "+352", "key": "LU" }, 
    { "value": "Macao", "text": "Macao", "dial_key": "+853", "key": "MO" }, 
    { "value": "Madagascar", "text": "Madagascar", "dial_key": "+261", "key": "MG" }, 
    { "value": "Malaysia", "text": "Malaysia", "dial_key": "+60", "key": "MY" }, 
    { "value": "Malta", "text": "Malta", "dial_key": "+356", "key": "MT" }, 
    { "value": "Marshall Islands", "text": "Marshall Islands", "dial_key": "+692", "key": "MH" }, 
    { "value": "Martinique", "text": "Martinique", "dial_key": "+596", "key": "MQ" }, 
    { "value": "Mauritania", "text": "Mauritania", "dial_key": "+222", "key": "MR" }, 
    { "value": "Mauritius", "text": "Mauritius", "dial_key": "+230", "key": "MU" }, 
    { "value": "Mexico", "text": "Mexico", "dial_key": "+52", "key": "MX" }, 
    { "value": "Moldova", "text": "Moldova", "dial_key": "+373", "key": "MD" }, 
    { "value": "Mongolia", "text": "Mongolia", "dial_key": "+976", "key": "MN" }, 
    { "value": "Morocco", "text": "Morocco", "dial_key": "+212", "key": "MA" }, 
    { "value": "Namibia", "text": "Namibia", "dial_key": "+264", "key": "NA" }, 
    { "value": "Netherlands", "text": "Netherlands", "dial_key": "+31", "key": "NL" }, 
    { "value": "New Zealand", "text": "New Zealand", "dial_key": "+64", "key": "NZ" }, 
    { "value": "Nigeria", "text": "Nigeria", "dial_key": "+234", "key": "NG" }, 
    { "value": "Norway", "text": "Norway", "dial_key": "+47", "key": "NO" }, 
    { "value": "Oman", "text": "Oman", "dial_key": "+968", "key": "OM" }, 
    { "value": "Panama", "text": "Panama", "dial_key": "+507", "key": "PA" },
    { "value": "Paraguay", "text": "Paraguay", "dial_key": "+595", "key": "PY" }, 
    { "value": "Peru", "text": "Peru", "dial_key": "+51", "key": "PE" }, 
    { "value": "Philippines", "text": "Philippines", "dial_key": "+63", "key": "PH" }, 
    { "value": "Poland", "text": "Poland", "dial_key": "+48", "key": "PL" }, 
    { "value": "Portugal", "text": "Portugal", "dial_key": "+351", "key": "PT" }, 
    { "value": "Qatar", "text": "Qatar", "dial_key": "+974", "key": "QA" }, 
    { "value": "Romania", "text": "Romania", "dial_key": "+40", "key": "RO" }, 
    { "value": "Rwanda", "text": "Rwanda", "dial_key": "+250", "key": "RW" }, 
    { "value": "Saudi Arabia", "text": "Saudi Arabia", "dial_key": "+966", "key": "SA" }, 
    { "value": "Senegal", "text": "Senegal", "dial_key": "+221", "key": "SN" }, 
    { "value": "Serbia", "text": "Serbia", "dial_key": "+381", "key": "RS" }, 
    { "value": "Singapore", "text": "Singapore", "dial_key": "+65", "key": "SG" }, 
    { "value": "Slovakia", "text": "Slovakia", "dial_key": "+421", "key": "SK" }, 
    { "value": "Slovenia", "text": "Slovenia", "dial_key": "+386", "key": "SI" }, 
    { "value": "South Africa", "text": "South Africa", "dial_key": "+27", "key": "ZA" }, 
    { "value": "Spain", "text": "Spain", "dial_key": "+34", "key": "ES" }, 
    { "value": "Sri Lanka", "text": "Sri Lanka", "dial_key": "+94", "key": "LK" }, 
    { "value": "Sweden", "text": "Sweden", "dial_key": "+46", "key": "SE" }, 
    { "value": "Switzerland", "text": "Switzerland", "dial_key": "+41", "key": "CH" }, 
    { "value": "United Republic of Tanzania", "text": "United Republic of Tanzania", "dial_key": "+255", "key": "TZ" }, 
    { "value": "Thailand", "text": "Thailand", "dial_key": "+66", "key": "TH" },
    { "value": "Trinidad and Tobago", "text": "Trinidad and Tobago", "dial_key": "+1868", "key": "TT" }, 
    { "value": "Tunisia", "text": "Tunisia", "dial_key": "+216", "key": "TN" }, 
    { "value": "Turkey", "text": "Turkey", "dial_key": "+90", "key": "TR" }, 
    { "value": "United Arab Emirates", "text": "United Arab Emirates", "dial_key": "+971", "key": "AE" }, 
    { "value": "Uruguay", "text": "Uruguay", "dial_key": "+598", "key": "UY" }, 
    { "value": "Uzbekistan", "text": "Uzbekistan", "dial_key": "+998", "key": "UZ" }, 
    { "value": "Vietnam","text": "Vietnam", "dial_key": "+84", "key": "VN" }, 
]


class RegisterBasicComponent extends Component {

    constructor() {
      super();
  
      this.state = {
        showPass: true,
        press: false,
        userID: '',
        firstName: '',
        lastName: '',
        username: '',
        password: '',
        passwordConfirm: '',
        email: '',
        emailAddress: '',
        phone_number: '',
        street: '',
        city: '',
        state: '',
        cardNum: '',
        expMon: '',
        expYr: '',
        cvc: '',
        zip: '',
        inputValueChecks: false,
        warningOverlay: true,
        phoneWarning: false,
        dialCode: '',
        scrollOverlay: false,
        phoneNumberCounter: 0,
        disableNextButton: false,
        countryDropDownOverlay: false,
        selectedLanguage: null,
        usernameDuplicateWarningBool: false,
        usernameDuplicateWarning: ' ',
        phoneNumberCounter: 0,
        usernameWarningOverlay: false,
        passwordWarningOverlay: true,
        waitOverlay: true,
        shortAddress: null,
        tokenID:'tokenID',
        charge: 'charge',
        country: null,
        countryCode: null,
        finalButton: null,
        buildingProfileOverlay: false,
        duplicateEmailOverlay: false,
        welcomeMessage: 'Building Your Profile ...\n\nDo not leave the app.',
        welcomeMessageColor: 'rgba(0, 158, 129, 1)',
        promoVerifiedBool: false,
        fcmToken: null,
        accountStillLoadingOverlay: true,
        checkingNow: false,
        termsAndConfirmationCodeOverlay: false,
        termsAcceptedBool: false,
        registrationCompleteA: false,
        registrationCompleteB: false,
        registrationCompleteC: false,
        walletAddress: null,
        shortAddress: null,
        ciphertext: null,
        activityIndicator: false,
        navigationDestinationObject: {
          navigationRoute: '',
        },
        registrationLoading: false,
        loadingText: '',
        verificationError: '',
        verificationNotice: '',
        accountConfirmed: false,
        freezeButtonsBool: false,
        selectedLanguage: null,
        mode_light_dark: null,
        currentUser: null,
        dropDownActiveBool: false,
        errorTags: null
                   }

      that = this; 

      
      

    }


    componentDidMount(){


      if(isMobile){
        // window.open("https://lenderblockcorp.com/blenderplatform","_self")
      }
  
      that.setState({
        selectedLanguage: localStorage.getItem('primaryLanguage'),
        mode_light_dark: localStorage.getItem('mode_light_dark'),
        errorTags: null
      })      

      axiosDoubleCallCounter = 0;
      clearInterval(checkValidAccountInterval);


          that.setState({
              // fcmToken,
              buildingProfileOverlay: false,
              welcomeMessage: 'Building Your Profile\n\nKeep Blender open.',
              welcomeMessageColor: 'rgba(0, 158, 129, 1)', 
              disableNextButton: false,
              duplicateEmailOverlay: false,
              promoVerifiedBool: false,
              authCode: "",
              freezeButtonsBool: false,
              dropDownActiveBool: false,
          })
      
    }

    _setContent(input) {
      navigator.clipboard.writeText(input)
      that.setState({
        copiedNotice: 'Copied!'
      })
    }

    checkValidAccountComplete(){
      clearInterval(checkValidAccountInterval);

      function checkStatus(){
          that.setState({
              checkingNow: true
          })
          setTimeout(() => {
              that.setState({
                  checkingNow: false
              })
          }, 3000)

          trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
              currentUser = res.username
              cognitoID = res.signInUserSession.idToken.jwtToken
          
              that.setState({
                currentUser
              })
              
              authenticatedPut('api1169ba1e', '', { 
                  headers: { Authorization: `Bearer ${cognitoID}` },
                  body: { 
                  category: 'db',
                  tableName: 'users', 
                  primaryKey: String(currentUser.toLowerCase()), 
                  requestOperation: 'get',
                  }
              }).then(async(userData) => {
                  if(userData){
                      if(userData.hasOwnProperty('Item')){
                          
                          
                          clearInterval(checkValidAccountInterval);

                          that.setState({
                              activityIndicator: false
                          }, () =>{


                            that.setState({
                              navigationDestinationObject: {
                                  navigationRoute: '/browser',
                                  routeProps: {
                                    prompt: 'register'
                                  }
                              },
                            })
                          })

                      } 
                  } 

              })
          })
      }

      checkStatus()

      checkValidAccountInterval = setInterval(() => {
          checkStatus()
      }, 10000)
    }

    async showRegistrationLoading(message) {
      this.setState({ registrationLoading: true, loadingText: message, freezeButtonsBool: true });
      // Let the browser paint the loading indicator before the next operation.
      await new Promise(resolve => setTimeout(resolve, 30));
    }

    async goToCredentials() {
      if (this.state.registrationLoading) return;
      if (!this.state.firstName.trim() || !this.state.lastName.trim() || !this.state.country) return;
      await this.showRegistrationLoading(this.state.selectedLanguage == 'spanish' ? 'Continuando…' : 'Continuing…');
      this.setState({ registrationCompleteA: true, registrationLoading: false, freezeButtonsBool: false });
    }

    async submitRegistration() {
      if (this.state.registrationLoading) return;
      const username = this.state.username.trim().toLowerCase();
      const emailAddress = this.state.emailAddress.trim();
      const password = this.state.password;
      const spanish = this.state.selectedLanguage == 'spanish';
      const validPassword = password.length >= 8 && !password.includes(' ') &&
        (password.match(/\d/g) || []).length >= 2 &&
        (password.match(/[A-Z]/g) || []).length >= 2 &&
        (password.match(/[a-z]/g) || []).length >= 2 &&
        (password.match(/[@#$%^&*()_+\-=\[\]{};!':"\\|,.<>\/?]/g) || []).length >= 2;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress) || username.length < 3 ||
          username.length >= 12 || username.includes('@') || !validPassword || password !== this.state.passwordConfirm) {
        this.setState({ errorTags: spanish ? 'Revise el correo, el usuario y las contraseñas. Las contraseñas deben coincidir y contener al menos 8 caracteres, con 2 números, 2 mayúsculas, 2 minúsculas y 2 caracteres especiales.' : 'Check your email, username, and passwords. Passwords must match and contain at least 8 characters, with 2 numbers, 2 uppercase letters, 2 lowercase letters, and 2 special characters.' });
        return;
      }
      await this.showRegistrationLoading(spanish ? 'Creando tu cuenta…' : 'Creating your account…');
      this.setState({ username, emailAddress, verificationError: '', verificationNotice: '' });
      try {
        await trackPageRequest(Auth.signUp({ username, password, attributes: { email: emailAddress } }));
        this.createNewWallet();
        this.setState({ registrationCompleteB: true, termsAndConfirmationCodeOverlay: true });
      } catch (error) {
        this.setState({ errorTags: error.code === 'UsernameExistsException' ?
          (spanish ? 'Este usuario ya existe. Inicia sesión o elige otro usuario.' : 'This username already exists. Sign in or choose another username.') :
          (spanish ? 'No se pudo crear tu cuenta. Revisa los datos e inténtalo de nuevo.' : 'Your account could not be created. Check your details and try again.') });
      } finally {
        this.setState({ registrationLoading: false, freezeButtonsBool: false });
      }
    }

    async resendConfirmationCode() {
      if (this.state.registrationLoading || this.state.accountConfirmed) return;
      const spanish = this.state.selectedLanguage == 'spanish';
      await this.showRegistrationLoading(spanish ? 'Enviando el código…' : 'Sending the code…');
      try {
        await trackPageRequest(Auth.resendSignUp(this.state.username.toLowerCase()));
        this.setState({ verificationError: '', verificationNotice: spanish ? 'Se envió un nuevo código a tu correo.' : 'A new code was sent to your email.' });
      } catch (error) {
        this.setState({ verificationError: spanish ? 'No se pudo reenviar el código. Espera un momento e inténtalo de nuevo.' : 'The code could not be resent. Wait a moment and try again.' });
      } finally {
        this.setState({ registrationLoading: false, freezeButtonsBool: false });
      }
    }

    async signIn() {
      await trackPageRequest(Auth.signIn(this.state.username.toLowerCase(), this.state.password));
      await trackPageRequest(Auth.currentCredentials());
      return await this.uploadProfile();
    }

    async confirmSignUp() {
      if (this.confirmationInProgress || this.state.registrationLoading) return;
      const spanish = this.state.selectedLanguage == 'spanish';
      const authCode = String(this.state.authCode || '').trim();
      if (!this.state.accountConfirmed && !/^\d{6}$/.test(authCode)) {
        this.setState({ verificationError: spanish ? 'Ingresa el código de 6 dígitos.' : 'Enter the 6-digit code.' });
        return;
      }
      this.confirmationInProgress = true;
      await this.showRegistrationLoading(spanish ? 'Verificando tu cuenta…' : 'Verifying your account…');
      this.setState({ verificationError: '', verificationNotice: '' });
      try {
        if (!this.state.accountConfirmed) {
          try {
            await trackPageRequest(Auth.confirmSignUp(this.state.username.toLowerCase(), authCode));
          } catch (error) {
            // A confirmed Cognito account must never be asked to confirm the same code again.
            if (error.code !== 'NotAuthorizedException' || !/already.*confirm|current status is confirmed/i.test(error.message || '')) throw error;
          }
          this.setState({ accountConfirmed: true });
        }
        this.setState({ loadingText: spanish ? 'Preparando tu cartera…' : 'Preparing your wallet…' });
        const profileReady = await this.signIn();
        if (profileReady) {
          await this.continue();
        } else {
          this.setState({
            verificationNotice: spanish ?
              'Tu registro está guardado. Tu cartera se está preparando. Pulsa Continuar en unos momentos.' :
              'Your registration is saved. Your wallet is being prepared. Select Continue in a few moments.',
            termsAndConfirmationCodeOverlay: true,
            buildingProfileOverlay: false
          });
        }
      } catch (error) {
        let message;
        if (error.code === 'CodeMismatchException') message = spanish ? 'El código no es correcto. Revisa tu correo e inténtalo de nuevo.' : 'The code is incorrect. Check your email and try again.';
        else if (error.code === 'ExpiredCodeException') message = spanish ? 'El código venció. Solicita uno nuevo.' : 'The code has expired. Request a new code.';
        else message = this.state.accountConfirmed ?
          (spanish ? 'Tu correo está verificado. No se pudo terminar la configuración. Pulsa Continuar para reintentarlo.' : 'Your email is verified. Setup could not finish. Select Continue to retry.') :
          (spanish ? 'No se pudo verificar tu cuenta. Inténtalo de nuevo.' : 'Your account could not be verified. Try again.');
        this.setState({ verificationError: message, termsAndConfirmationCodeOverlay: true, buildingProfileOverlay: false });
      } finally {
        this.confirmationInProgress = false;
        this.setState({ registrationLoading: false, freezeButtonsBool: false });
      }
    }

    async uploadProfile() {
      if (this.profileUploadPromise) return this.profileUploadPromise;
      this.profileUploadPromise = this.saveRegistrationProfile();
      try { return await this.profileUploadPromise; }
      finally { this.profileUploadPromise = null; }
    }

    async saveRegistrationProfile() {
      const username = this.state.username.toLowerCase();
      const emailAddress = this.state.emailAddress.trim().toLowerCase();
      const session = await trackPageRequest(Auth.currentSession());
      cognitoID = session.idToken.jwtToken;
      const request = async body => {
        const response = await authenticatedPut('api1169ba1e', '', {
          headers: { Authorization: `Bearer ${cognitoID}` }, body });
        if (response && response.statusCode != null &&
            (Number(response.statusCode) < 200 || Number(response.statusCode) >= 300)) {
          throw new Error('Registration database request failed');
        }
        const result = response && response.body != null ? response.body : response;
        return typeof result === 'string' ? JSON.parse(result) : result;
      };
      const existing = await request({ category: 'db', tableName: 'users', primaryKey: username, requestOperation: 'get' });
      const profileIsReady = profile => Boolean(profile &&
        profile.publicKey && profile.privateKey && profile.firstName && profile.emailAddress &&
        Array.isArray(profile.proxyPostHashArray) && profile.proxyPostHashArray.length === 11 &&
        Array.isArray(profile.proxyPreHashArray) && profile.proxyPreHashArray.length === 11 &&
        Array.isArray(profile.receipts) && profile.preferences && profile.blenderScore != null);
      if (existing && profileIsReady(existing.Item)) return true;
      if (!this.state.walletAddress || !this.state.ciphertext) throw new Error('Registration wallet is not ready');


      // Reuse the Identity Pool and login provider already configured in Amplify.
      const credentials = await trackPageRequest(Auth.currentCredentials());
      if (!credentials || !credentials.accessKeyId || !credentials.secretAccessKey || !credentials.sessionToken) {
        throw new Error('Authenticated AWS credentials are unavailable');
      }
      const registrationCredentials = new AWS.Credentials({
        accessKeyId: credentials.accessKeyId,
        secretAccessKey: credentials.secretAccessKey,
        sessionToken: credentials.sessionToken
      });
      AWS.config.credentials = registrationCredentials;
      const client = new AWS.SecretsManager({ region, credentials: registrationCredentials });
      const secret = await trackPageRequest(client.getSecretValue({ SecretId: secretName }).promise());
      const secretText = secret.SecretString || Buffer.from(secret.SecretBinary, 'base64').toString('utf8');
      let encryptSecret = JSON.parse(secretText).blenderProxyPrivateKey;
      function randomText(length) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_&*#';
        let text = '';
        for (let i = 0; i < length; i++) text += characters.charAt(Math.floor(Math.random() * characters.length));
        return text;
      }
      const encryptedPassword = String(CryptoJS.AES.encrypt(randomText(64) + this.state.password + randomText(64), encryptSecret));
      encryptSecret = null;
      const emailRecord = await request({ category: 'db', tableName: 'general', primaryKey: 'userEmailAddresses', requestOperation: 'get' });
      const emails = emailRecord && emailRecord.Item && emailRecord.Item.userEmailAddresses || [];
      const exemptEmails = ['lewismichael365@gmail.com', 'lenderblock@gmail.com', 'tbp_borrowingadmin@lenderblockcorp.com'];
      if (emails.includes(emailAddress) && !this.profileEmailReserved && !exemptEmails.includes(emailAddress)) {
        throw new Error('Email address is already registered');
      }
      if (!emails.includes(emailAddress)) {
        await request({ category: 'db', tableName: 'general', primaryKey: 'userEmailAddresses', requestOperation: 'update',
          updateExpression: 'SET userEmailAddresses = list_append(userEmailAddresses, :newEmail)',
          expressionAttributeValues: { ':newEmail': [emailAddress] } });
      }
      this.profileEmailReserved = true;
      await request({ category: 'db', tableName: 'userpks', primaryKey: username, requestOperation: 'update',
        updateExpression: 'SET encryptedPK = :encryptedPK', expressionAttributeValues: { ':encryptedPK': encryptedPassword } });
      if (!this.registrationDraft) {
        const randomString = (String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)).substring(0, 18);
        const proxyPreHashArray = [], proxyPostHashArray = [];
        const hashingClient = new Web3();
        for (let i = 0; i <= 10; i++) {
          const text = randomText(32);
          proxyPreHashArray.push(text);
          proxyPostHashArray.push(hashingClient.utils.soliditySha3(text));
        }
        this.registrationDraft = { application: 'TBP', appliedPromoCode: this.state.promoCode,
          username, newPromoCode: randomString.substring(12, 16), randomString,
          firstName: this.state.firstName, lastName: this.state.lastName, emailAddress,
          publicKey: this.state.walletAddress, privateKey: this.state.ciphertext,
          proxyPostHashArray, proxyPreHashArray, squareCustomerID: 'null',
          preferences: { primaryDisplayCurrency: 'USD', secondaryDisplayCurrency: 'EUR', primaryLanguage: this.state.selectedLanguage || 'english' },
          deviceTokenFCM: this.state.fcmToken, devicePlatform: 'desktop', country: this.state.country };
      }
      // The worker reads application and registrationData from pendingRegistrations.
      // Save the complete payload before adding the username to its queue.
      if (!this.profileDataSaved) {
        await request({ category: 'db', tableName: 'pendingRegistrations', primaryKey: username,
          requestOperation: 'update',
          updateExpression: 'SET application = :application, registrationData = :registrationData',
          expressionAttributeValues: {
            ':application': 'TBP',
            ':registrationData': this.registrationDraft
          } });
        let saved;
        for (let attempt = 0; attempt < 3; attempt++) {
          if (attempt) await new Promise(resolve => setTimeout(resolve, 500));
          saved = await request({ category: 'db', tableName: 'pendingRegistrations',
            primaryKey: username, requestOperation: 'get' });
          if (saved && saved.Item && saved.Item.application === 'TBP' &&
              saved.Item.registrationData &&
              saved.Item.registrationData.randomString === this.registrationDraft.randomString &&
              saved.Item.registrationData.publicKey === this.registrationDraft.publicKey &&
              saved.Item.registrationData.privateKey === this.registrationDraft.privateKey) break;
        }
        if (!saved || !saved.Item || saved.Item.application !== 'TBP' ||
            !saved.Item.registrationData ||
            saved.Item.registrationData.randomString !== this.registrationDraft.randomString ||
            saved.Item.registrationData.publicKey !== this.registrationDraft.publicKey ||
            saved.Item.registrationData.privateKey !== this.registrationDraft.privateKey) {
          throw new Error('Registration data could not be verified in pendingRegistrations');
        }
        this.profileDataSaved = true;
      }
      if (!this.profileQueued) {
        const queue = await request({ category: 'db', tableName: 'general',
          primaryKey: 'pendingUserRegistrationsArray', requestOperation: 'get' });
        if (!(queue && queue.Item && queue.Item.pendingUserRegistrationsArray || []).includes(username)) {
          await request({ category: 'db', tableName: 'general', primaryKey: 'pendingUserRegistrationsArray',
            requestOperation: 'update',
            updateExpression: 'SET pendingUserRegistrationsArray = list_append(if_not_exists(pendingUserRegistrationsArray, :emptyList), :newUser)',
            expressionAttributeValues: { ':emptyList': [], ':newUser': [username] } });
        }
        this.profileQueued = true;
      }
      // Queued registration is not an error. Navigate only after the worker saves the profile.
      for (let attempt = 0; attempt < 6; attempt++) {
        if (attempt) await new Promise(resolve => setTimeout(resolve, 2000));
        const profile = await request({ category: 'db', tableName: 'users',
          primaryKey: username, requestOperation: 'get' });
        if (profile && profileIsReady(profile.Item)) return true;
      }
      return false;
    }


    createNewWallet(){ 



        var mnemonic = bip39.generateMnemonic(); 
        
        function preSalt(length) {
          var result           = '';
          var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_&*#';
          var charactersLength = characters.length;
          for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
          }
          return result;
        }

        function postSalt(length) {
          var result           = '';
          var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_&*#';
          var charactersLength = characters.length;
          for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() * charactersLength));
          }
          return result;
        }

        var preSalt = String(preSalt(64))
        var postSalt = String(postSalt(64))

        const { password } = this.state

        var ciphertext = CryptoJS.AES.encrypt(preSalt.concat(mnemonic).concat(postSalt), password);


        let mnemonicWallet = ethers.Wallet.fromMnemonic(mnemonic);
        let mnemonicAddress = mnemonicWallet.address;

       

        mnemonic = null
        ciphertext = String(ciphertext)


          this.setState({
            walletAddress: mnemonicAddress,
            shortAddress: mnemonicAddress.substr(0,1).concat('x').concat(mnemonicAddress.substr(2, 10)).concat('...').concat(mnemonicAddress.substr(mnemonicAddress.length-10, mnemonicAddress.length-1)),
            ciphertext,
            preSalt,
            postSalt,
            waitOverlay: false,
            
          });

        


    }

    
    continue = (choice) => {

      var randomString
      var newPromoCode


            return trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
              let primaryDisplayCurrency, cognitoID, username;

                username = res.username
                cognitoID = res.signInUserSession.idToken.jwtToken


                primaryDisplayCurrency = 'USD'

                let price_usd = 1;
                price_usd = parseFloat(price_usd, 10)
                

                if(that.state.emailAddress != 'lewismichael365@gmail.com'){

                    var sns = new AWS.SNS();
                    let messageText = `TBP - New User !\n\n ${that.state.username.toUpperCase()} (desktop) - ${that.state.country.toUpperCase()}`
                    var params1 = {
                        Message: messageText,
                        MessageStructure: 'string',
                        PhoneNumber: '+14434478737'
                    };
                    var params2 = {
                        Message: messageText,
                        MessageStructure: 'string',
                        PhoneNumber: '+14438571326'
                    };
                    sns.publish(params1, function(err, data) {});
                    sns.publish(params2, function(err, data) {});
                }

                
                that.setState({
                    buildingProfileOverlay: false,
                    termsAndConfirmationCodeOverlay: false,
                    activityIndicator: true
                })   


                randomString = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                newPromoCode =  randomString.substring(12,16)


              
                that.setState({
                  navigationDestinationObject: {
                      navigationRoute: '/browser',
                      routeProps: {
                        prompt: 'register'
                      }
                  },
                })

                
              
            })
        
    }

    render(){
      applicantUsername = that.props.username
   
      const { touched } = that.state;
      const className = touched ? 'button1_touched' : 'button1';

      if(navigationHandler(that.state.navigationDestinationObject)){
          return navigationHandler(that.state.navigationDestinationObject)
      }
      const renderProps = { API, AWS, Amplify, Auth, Buffer, Button, ButtonContent, ButtonGroup, CampaignContract_latest, CampaignFactoryContract_latest, Component, Container, CryptoJS, Dropdown, DropdownMenu, Form, FormField, Fragment, Header, Icon, Image, Input, LENDERBLOCKADMINWHITELIST, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, Radio, React, Storage, ThreeDot, Web3, applicantUsername, awsconfig, axios, axiosDoubleCallCounter, bip39, blenderCommissionPublicKey, blenderTransfersToPublicKey, checkValidAccountInterval, checkValidAuthTokenInterval, checkValidAuthTokenIntervalPeriod_ms, className, cognitoID, countryCodesJSON, createAccountTimer, currentUser, deploymentAddressLatest, ethers, isMobile, mimemessage, mode_light_dark, navigationHandler, primaryLanguage, region, register, routeProps, secretName, startCount, that, tokenLifeTimeLimit, touched, useParams, useRef, web3, weiBalance };

      if (isMobile) {
        return <RegisterMobileRender {...renderProps} />;
      }

      return <RegisterDesktopRender {...renderProps} />;
    }

}


function register(props){
  return (<RegisterBasicComponent/>)
}

export default register;
